import _ from 'lodash';
import { useEffect, useState } from 'react';

function useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns) {
  // ---- params ----
  const [fullColumnItems, setFullColumnItems] = useState(fullColumns || []);
  const [columnIds, setColumnIds] = useState(defaultColumnIds || []);
  const [pendingColumnIds, setPendingColumnIds] = useState(defaultColumnIds || []);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    const key = `${prefKey}_FULL_COLUMN_IDS`;
    const value = localStorage.getItem(key);
    let updatedColumnIds = fullColumnIds?.filter(Boolean) || [];

    if (value) {
      const storedColumnIds = value.split('|').filter(Boolean);
      const newColumnIds = (fullColumnIds || []).filter((columnId) => !storedColumnIds.includes(columnId));
      updatedColumnIds = [...storedColumnIds, ...newColumnIds];
    }

    const ret = updatedColumnIds
      .map((columnId) => _.find(fullColumns, (item) => item?.id === columnId))
      .filter(Boolean);
    const noIdColumns = _.filter(fullColumns, (item) => !item?.id);
    setFullColumnItems([...ret, ...noIdColumns]);
  }, [fullColumnIds, fullColumns, prefKey]);

  useEffect(() => {
    const prefValue = localStorage.getItem(prefKey);
    const initialColumnIds = prefValue
      ? prefValue.split('|').filter(Boolean)
      : defaultColumnIds || [];
    setColumnIds(initialColumnIds);
    setPendingColumnIds(initialColumnIds);
  }, [prefKey, defaultColumnIds]);

  useEffect(() => {
    const tmpColumns = (fullColumnItems || []).filter(
      (item) => (item?.id && columnIds.includes(item?.id)) || _.isUndefined(item?.id)
    );

    const safeColumns = tmpColumns.map((col) => ({
      ...col,
      sortable: col?.sortable !== undefined ? col.sortable : false,
    }));

    if (safeColumns.length > 1) {
      safeColumns[safeColumns.length - 2].style = {
        ...safeColumns[safeColumns.length - 2].style,
        borderRight: 0,
      };
    }

    setColumns(safeColumns);
  }, [columnIds, fullColumnItems]);

  const onChangeCheckboxValue = (key, checked) => {
    let tmpColumnIds = [...pendingColumnIds];
    if (!checked) {
      tmpColumnIds = tmpColumnIds.filter((row) => row !== key);
    } else if (!tmpColumnIds.includes(key)) {
      tmpColumnIds.push(key);
    }
    setPendingColumnIds(tmpColumnIds);
  };

  const saveChanges = () => {
    setColumnIds(pendingColumnIds);
    localStorage.setItem(prefKey, pendingColumnIds.join('|'));
  };

  const resetDefaultTableColumn = () => {
    setPendingColumnIds(defaultColumnIds || []);
    setColumnIds(defaultColumnIds || []);
    localStorage.setItem(prefKey, (defaultColumnIds || []).join('|'));
    const key = `${prefKey}_FULL_COLUMN_IDS`;
    localStorage.setItem(key, (defaultColumnIds || []).join('|'));
  };

  const onSelectAll = () => {
    setPendingColumnIds(fullColumnIds?.filter(Boolean) || []);
  };

  const onUnSelectAll = () => {
    setPendingColumnIds([]);
  };

  return {
    columnIds,
    columns,
    onChangeCheckboxValue,
    saveChanges,
    resetDefaultTableColumn,
    onSelectAll,
    onUnSelectAll,
    fullColumnsSorted: fullColumnItems,
    fullColumnsIdSorted: (fullColumnItems || []).filter(item => !item.omit).map((item) => item?.id).filter(Boolean),
  };
}

export default useConfigTableColumn;
